import { combineReducers } from 'redux';

import authReducer from './authReducer';
import workflowReducer from './workflowReducer';
import breadcrumbReducer from './breadcrumbReducer';
import { notificationsReducer } from './notificationsReducer';
import userReducer from './userReducer';
import sidebarReducer from './sidebarReducer';
import { schedulesReducer } from './scheduleReducer';
import datetimeReducer from './datetimeReducer';
import { userSettingsReducer } from './userSettingsReducer';
import partnerReducer from './partnerReducer';
import chatReducer from './chatReducer'

// Combine all reducers
const rootReducer = combineReducers({
  user: userReducer,
  auth: authReducer,
  workflow: workflowReducer,
  breadcrumbs: breadcrumbReducer,
  notifications: notificationsReducer,
  sideBar: sidebarReducer,
  schedules: schedulesReducer,
  dateTime: datetimeReducer,
  userSettings: userSettingsReducer,
  partner: partnerReducer,
  chat: chatReducer,
});

export default rootReducer;
